module.exports = __webpack_public_path__ + "img/business_license.4aa0fcbd.png";